import React from 'react';
import num from '@nerdwallet/nw-client-lib/num';
import { Text, Box, Stack } from '@nerdwallet/currency';

interface HomeValueProps {
  data: Record<string, any>;
}

export const HomeValue: React.FC<HomeValueProps> = (props) => {
  const { data } = props;
  const originalHomePrice = data.outputs.suggestedPurchasePrice;
  const adjustedHomePrice = data.adjustedOutputs.suggestedPurchasePrice;
  const homeValueStr =
    adjustedHomePrice > 0
      ? num.formatCurrency(data.adjustedOutputs.suggestedPurchasePrice)
      : '_ _';

  return (
    <Box>
      <Box paddingY={4} paddingX={3}>
        <Stack spacing={0}>
          <Text size="large" bold>
            {homeValueStr}
          </Text>
          {originalHomePrice !== adjustedHomePrice && (
            <Text size="small">
              {`Suggested: ${num.formatCurrency(originalHomePrice)}`}
            </Text>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default HomeValue;
